import React from "react";
import { Box, Typography, Button } from "@mui/material";
import Grid from "@mui/material/Grid";
import AppleIcon from "@mui/icons-material/Apple";
import AdbIcon from "@mui/icons-material/Adb";
import { useTranslation } from "react-i18next";
import phone from "assets/phone.svg";
import { APP_STORE_URL, GOOGLE_PLAY_STORE_URL } from "utils/constants";
import twigoLogo from "assets/logo1.png";
const MobileApps = () => {
  const { t } = useTranslation();

  const openAppStoreInNewTab = () => {
    window.open(APP_STORE_URL, "_blank");
  };

  const openGooglePlayInNewTab = () => {
    window.open(GOOGLE_PLAY_STORE_URL, "_blank");
  };

  return (
    <Box
      sx={{
        padding: { xs: 2, sm: 4, md: 6 },
        backgroundColor: "#f5f5f5",
        borderRadius: 2,
        height: "100vh",
        justifyContent: "center",
        alignItems: "center",
        display: "flex",
      }}
    >
      <Grid
        container
        spacing={4}
        alignItems="center"
        sx={{
          flexDirection: { xs: "column", sm: "row" },
        }}
      >
        {/* Phone Image */}
        <Grid
          item
          xs={12}
          md={6}
          sx={{
            display: "flex",
            justifyContent: "center",
            order: { xs: 1, sm: 2 },
          }}
        >
          <Box
            component="img"
            src={phone}
            alt="Mobile app preview"
            sx={{
              maxWidth: "100%",
              height: "auto",
              maxHeight: { xs: "300px", md: "400px" },
              transform: { xs: "none", md: "rotate(-5deg)" },
              transition: "transform 0.3s ease",
              "&:hover": {
                transform: { xs: "none", md: "rotate(0deg)" },
              },
            }}
          />
        </Grid>

        {/* Text and Buttons */}
        <Grid
          item
          xs={12}
          md={6}
          sx={{
            order: { xs: 2, sm: 1 },
          }}
        >
          <Box
            sx={{
              textAlign: { xs: "center", sm: "left" },
            }}
          >
            <img width="200px" height="88.61px" src={twigoLogo} />
            <Typography
              variant="h4"
              component="h2"
              sx={{
                fontWeight: 700,
                marginBottom: 3,
                color: "#207DB9",
              }}
            >
              {t("AUTH.DOWNLOAD")}
            </Typography>
          </Box>

          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              gap: 2,
              marginBottom: 4,
            }}
          >
            <Button
              variant="contained"
              startIcon={<AppleIcon />}
              onClick={openAppStoreInNewTab}
              sx={{
                backgroundColor: "#E24399",
                padding: "12px 24px",
                "&:hover": {
                  backgroundColor: "#333",
                },
                flex: { sm: 1 },
              }}
            >
              {t("AUTH.BUTTONS.DOWNLOAD_IOS_APP")}
            </Button>

            <Button
              variant="contained"
              startIcon={<AdbIcon />}
              onClick={openGooglePlayInNewTab}
              sx={{
                backgroundColor: "#17171B",
                padding: "12px 24px",
                "&:hover": {
                  backgroundColor: "#558b2f",
                },
                flex: { sm: 1 },
              }}
            >
              {t("AUTH.BUTTONS.DOWNLOAD_ANDROID_APP")}
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default MobileApps;
